var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M18.875 6L6.875 18M6.875 6L18.875 18","stroke":"#262626","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }